// extracted by mini-css-extract-plugin
export default {"host":"InvalidTypeInput_host__bdr2a"};